module.exports = __webpack_public_path__ + "static/img/200320.37ed436c.png";